export const getAllFormTemplates = (api, tokenType) => {
  return api.get("/formtemplate", { tokenType });
};

export const getAllFormTemplatesSourceNames = (api, tokenType) => {
  return api.get("/formtemplate/SourceName", { tokenType });
};

export const getAllFormTemplatesQualifications = (api, tokenType) => {
  return api.get("/formtemplate/Qualification", { tokenType });
};

export const getAllFormTemplatesLocations = (api, tokenType) => {
  return api.get("/formtemplate/location", { tokenType });
};

export const getAllFormTemplatesPositions = (api, tokenType) => {
  return api.get("/formtemplate/position", { tokenType });
};

export const getAllFormTemplatesModeOfInterviews = (api, tokenType) => {
  return api.get("/formtemplate/modeOfInterview", { tokenType });
};

export const getAllFormTemplatesLanguages = (api, tokenType) => {
  return api.get("/formtemplate/languages", { tokenType });
};

export const getAllFormTemplatesNoticePeriod = (api, tokenType) => {
  return api.get("/formtemplate/noticePeriod", { tokenType });
};

export const getAllFormTemplatesIndustry = (api, tokenType) => {
  return api.get("/formtemplate/industries", { tokenType });
};
